<template></template>

<script>
export default {
  mounted() {
    this.$utils.forceLogout(this);
  },
};
</script>

<style></style>
